export default __webpack_public_path__ + "static/media/wedding.881a0453.jpg";